export default __webpack_public_path__ + "static/media/AF.1369efe6.svg";